<template>
  <div class="TextContainer" :class="{'large': large}">

    <slot>
    </slot>

  </div>
</template>

<script>

//import component from '@assets/components/component.vue'

export default {
  name: 'TextContainer',
  components: {
    //component
  },
  props: {
    large: Boolean
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.TextContainer{
  padding: 10px;
  max-width: 80%;
  align-self: center;
  background: white;
  text-align: center;
}

.large{
  font-size: 1.1em;
}

</style>
